var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('LineChart',{staticClass:"pa-4",attrs:{"data":{labels: _vm.getChartLabels, datasets: _vm.getChartValues},"options":_vm.options,"min":0}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }